






import { Component, Vue } from 'vue-property-decorator';
import CarList from '@/components/Car/CarList.vue';

@Component({
  components: {
    CarList,
  },
})
export default class Cars extends Vue {}
